import { createSlice } from '@reduxjs/toolkit'

const pageDatas = createSlice({
  name: 'pageData',
  initialState: {
    infos: {
      channels: {},
      factory: {},
      // 查询/筛选表单专用:启用+停用工厂(停用沉底)。录入表单必须继续用 factory,防止新单据挂到停用工厂
      factoryWithDisabled: {},
      supplier: {}
    },
    exchangeTranslateFlag: false
  },
  reducers: {
    setPageDataChannels(state, action) {
      state.infos.channels = action.payload
    },
    setPageDataFactory(state, action) {
      state.infos.factory = action.payload
    },
    setPageDataFactoryWithDisabled(state, action) {
      state.infos.factoryWithDisabled = action.payload
    },
    setPageDataSupplier(state, action) {
      state.infos.supplier = action.payload
    },
    setExchangeTranslateFlag(state, action) {
      state.exchangeTranslateFlag = action.payload
    }
  }
})

const {
  actions,
  reducer
} = pageDatas;

export const {
  setPageDataChannels,
  setPageDataFactory,
  setPageDataFactoryWithDisabled,
  setPageDataSupplier,
  setExchangeTranslateFlag,
} = actions

export default reducer